import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ReviewForm from "@/components/ReviewForm";
import api from "@/lib/api";

export default function ReviewSubmit() {
  async function handleSubmit(form) {
    await api.post("/reviews", {
      name: form.name,
      rating: form.rating,
      text: form.text,
      car: form.car,
      city: form.city,
      designation: form.designation,
      photo: form.photo,
    });
  }

  return (
    <main className="relative bg-void text-silver min-h-screen" data-testid="review-submit-page">
      <Navbar />
      <section className="relative pt-40 md:pt-48 pb-20 md:pb-28">
        <div className="max-w-[640px] mx-auto px-5 md:px-10">
          <p className="eyebrow gradient-text">Your Saarthi. Never Theirs.</p>
          <h1 className="mt-6 font-serif text-white text-4xl sm:text-5xl leading-[1.02] tracking-tight">
            How was your <span className="italic gradient-text">experience?</span>
          </h1>
          <p className="mt-4 text-silver/70 leading-relaxed">
            Bought a car through CaarSaarthi? A couple of honest lines help the next buyer trust us the way you did.
          </p>
          <div className="mt-10">
            <ReviewForm fields={["name", "car", "city"]} onSubmit={handleSubmit} submitLabel="Submit review" />
          </div>
          <p className="mt-6 text-center text-xs text-silver/40">
            Already have an account? <Link to="/dashboard" className="underline hover:text-white">Leave a review from your dashboard</Link> instead.
          </p>
        </div>
      </section>
      <Footer />
    </main>
  );
}
